import React from 'react'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import * as Auth from '@morningtrain/react-auth'
import { SubmitFormOnPipe, WhenModelValue } from '@morningtrain/react-resources'
import ValidateAllItemsHasReceivedOnPipe from 'widgets/inventory/ValidateAllItemsHasReceivedOnPipe'
import { ConditionalNestedPipeline } from '@morningtrain/react-pipelines'
import GetExtraFormDataPipes from 'support/pipelines/GetExtraFormDataPipes'
import { TextArea } from 'support/fields'
import { SubmitButton } from 'ui'

export default function ReceiveOrder (props) {
  return (
    <WhenModelValue name='status' condition={s => ['completed'].includes(s)}>
      <Auth.Can permission='api.inventory.order.store'>
        <Pipeline>
          <TriggerPipelineOnClick>
            <Button>
              <Translation name='actions.receive_order' />
            </Button>
          </TriggerPipelineOnClick>
          <ValidateAllItemsHasReceivedOnPipe />
          <ConditionalNestedPipeline when='any_has_should_office_handle' matches>
            <GetExtraFormDataPipes submitButton={<Button text={<Translation name='inventory.fragments.office_note_submit' />} />}>
              <TextArea name='office_should_handle_note' required label={<Translation name='inventory.fragments.office_note_label' />} />
            </GetExtraFormDataPipes>
          </ConditionalNestedPipeline>
          <SubmitFormOnPipe data={{ status: 'received' }} mergeDataFromPayload />
        </Pipeline>
      </Auth.Can>
    </WhenModelValue>
  )
}
